// src/hooks/useModals.js
import { useState } from 'react';

export function useModals() {
  const [modals, setModals] = useState({
    cancelar: false,
    transferir: false,
    confirmar: false,
    invitarAmigos: false,
    crearEmpresa: false,
    crearEvento: false,
    publicarEvento: false,
    crearPuerta: false,
    register: false,
    signIn: false,
  });

  const openModal = (modalName) => {
    setModals(prev => ({ ...prev, [modalName]: true }));
  };

  const closeModal = (modalName) => {
    setModals(prev => ({ ...prev, [modalName]: false }));
  };

  const closeAllModals = () => {
    setModals({
      cancelar: false,
      transferir: false,
      confirmar: false,
      invitarAmigos: false,
      crearEmpresa: false,
      crearEvento: false,
      publicarEvento: false,
      crearPuerta: false,
      register: false,
      signIn: false,
    });
  };

  return {
    modals,
    openModal,
    closeModal,
    closeAllModals,
  };
}